import { useRequest } from 'ahooks';
import { getSuggest } from '@/pages/search/service';
import { removeBlank } from '@/utils/string';
import { searchReport } from '@/pages/search/report';
import { EnumSearchBiz } from '@/pages/search/constants';
/**
 * 搜索建议的使用场景
 * search-bar: 全局下拉框
 * search-result: 结果页下拉框
 */
export const suggestionBizMap = {
  'search-bar': EnumSearchBiz.SuggestionsInSearchBar,
  'search-result': EnumSearchBiz.SuggestionsInResultPage,
} as const;

export const useSearchRecommends = () => {
  /** 请求 */
  const {
    data: res = [],
    run: fetch,
    loading,
  } = useRequest(
    async (str = '', biz: (typeof suggestionBizMap)[keyof typeof suggestionBizMap]) => {
      try {
        const { records = [], requestId, opsRequestMisc } = await getSuggest(removeBlank(str), biz);
        // OpenSearch数据上报 - 搜索曝光
        searchReport({
          bhvType: 'expose',
          bhvValue: '',
          rn: requestId,
          traceInfo: opsRequestMisc,
          itemIdList: records.map((item) => item.id),
        });
        return records.slice(0, 5).map((record) => {
          // 将搜索的相关埋点参数填入每个搜索结果中，后续每个元素的行为上报需要用到;
          record.requestId = requestId;
          record.opsRequestMisc = opsRequestMisc;
          return record;
        });
      } catch (err) {
        console.error(err);
        return [];
      }
    },
    {
      manual: true,
    }
  );

  return {
    loading,
    fetch,
    res,
  };
};
